import { defineStore } from 'pinia';
import { ref, readonly } from 'vue';

export const useAppState = defineStore('appState', () => {
  const isScrolling = ref(false);

  const setScrolling = (scrolling: boolean) => {
    isScrolling.value = scrolling;
  };

  return {
    isScrolling: readonly(isScrolling),
    setScrolling,
  };
});
